module.exports = __webpack_public_path__ + "87ff6458295ef46d83357353aa45ae76-pipelines_leak_recognition_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/ugiPipelines/assets/pipelines_leak_recognition_2x.png
// module id = 832
// module chunks = 0